// src/store/sitemapMiddleware.js
import axios from "axios";
import { serverPath } from "config/config";

const updateSitemap = async (actionType) => {
  try {
    const startTime = Date.now();

    const response = await axios.get(`${serverPath}/scripts/generatesitemap.php`, {
      params: { trigger: actionType },
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    return true;
  } catch (error) {
    console.error("[Sitemap] Error:", {
      message: error.message,
      config: error.config,
      response: error.response?.data,
    });
    return false;
  }
};

export const sitemapMiddleware = (store) => (next) => async (action) => {
  const result = next(action);

  const triggers = {
    "articles/createArticle/fulfilled": "CREATE",
    "articles/updateArticle/fulfilled": "UPDATE",
    "articles/deleteArticle/fulfilled": "DELETE",
  };

  if (triggers[action.type]) {
    try {
      // Задержка для гарантии обновления данных
      setTimeout(async () => {
        await updateSitemap(triggers[action.type]);
      }, 500);
    } catch (e) {
      console.error("[Sitemap] Middleware error:", e);
    }
  }

  return result;
};
